//import DogeBackground from 'assets/DogeWeTrust_B.webp';
import './styles.css';

// so this currently doesn't work at all. I, Michael, moved it out of each page into its own functional component
// unfortunately, it now behaves oddly. It's supposed to be 100vh x 100vw; but instead it get drawn
// from 100vh to 200vh, 100vw wide. Which is not the intended behavior.
// If someone will want this to start working again - you might need to put this <div> back into every page

function PageBackground() {
  return null;
  return (<div className='PageBackground'>
    {/* <img src={DogeBackground} alt='DogeBackground' /> */}
  </div>);
}

export default PageBackground;
